// Show text in user's language
export default function languageFilter(object = {}, field = 'title', userLang = 'pl') {
  return object?.lang?.[field]?.[userLang] || object?.[field]
}
